import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {login} from 'apa/actions';
import {Button, Card, CardBody, CardFooter, CardHeader, Container, FormGroup, Input, Label} from 'reactstrap'
import Loading from 'apa/components/Loading';
import autobind from 'autobind-decorator';
import { Redirect } from 'react-router-dom';

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array
}

function chooseQuestions(questionList, number) {
    const n = parseInt(number);
    const max = Math.min(questionList.length, n)
    const questions = shuffleArray(questionList, max);
    const n_q = questions.slice(0, max);
    for(let i = 0; i < n_q.length; i++) {
        const answers = n_q[i].answers;
        if(answers)  {
            n_q[i].answers = shuffleArray(answers, 6).slice(0, 6)
        }
    }
    return n_q
}

@connect(
    state => {
        return {
            auth: state.apa
        }
    }
)
class T extends Component {

    state = {
        current: 0,
        questions: [],
        selected: {},
        isLoading: false,
        results: {}
    }

    constructor(props) {
        super(props);
        const status = props.auth.user.access_code.status
        if(status === 2) {
            this.state.questions = props.questions.slice(0, 3)
        } else {
            this.state.questions = props.questions
        }
        props.questions.filter(
            val => this.state.selected[val.idx] = []
        )
    }

    @autobind
    onSubmit() {
        const headers = {
            'Authorization': `Token ${this.props.auth.token}`,
            'Content-Type': 'application/json'
        };
        const questions = [...this.state.questions]
        console.log("Questions", questions)
        for(let i = 0; i < questions.length; i++) {
            const question = questions[i];
            const answers = question.answers;
            for(let j = 0; j < answers.length; j++) {
                const answer = answers[j]
                answer.selected = this.state.selected[question.idx].indexOf(answer.idx) > -1
            }
        }
        const f_results = []
        // Code to store the previous attempted questions
        // const access_code = this.props.auth.user.access_code
        // if(access_code.results.results) {
        //     f_results.push(...access_code.results.results)
        // }
        f_results.push(...questions)
        const body = JSON.stringify(
            {
                'results': f_results
            }
        )
        console.log("Body", body)
        fetch(
            'https://apabackend.quixtest.de/api/auth/user/submit/',
            {headers, method: 'POST', body}
        ).then(res => res.json())
            .then(
                (res) => {
                    this.setState({isLoading: false})
                    window.location.replace('/training/status');
                }
            )
    }

    render() {
        if(this.state.isLoading) {
            return <Loading/>
        }
        const current = this.state.current;
        const questions = this.state.questions;
        const max = questions.length;
        const question = questions[current]
        const answers = question.answers || []
        const isSelected = (answer) => {
            if(this.state.selected[question.idx]) {
                const a = this.state.selected[question.idx].indexOf(answer.idx) > -1
                return a
            }
            return false
        }
        return (
            <Card style={{'width': '40em', 'margin': 'auto'}}>
                <CardHeader>
                    <strong>{question.text}</strong>
                </CardHeader>
                <CardBody>
                    {
                        answers.map((answer => (
                            <FormGroup key={`answer_${answer.idx}`} check>
                                <Label>
                                <Input type="checkbox"
                                       checked={isSelected(answer)}
                                       value={`answer_check_${answer.idx}`}
                                       onChange={
                                           e => {
                                               const selected = {...this.state.selected}
                                               if(e.target.checked) {
                                                   const s = selected[question.idx]
                                                       if(s) {
                                                           selected[question.idx].push(answer.idx)
                                                       } else {
                                                           selected[question.idx] = [answer.idx]
                                                       }
                                               } else {
                                                   selected[question.idx].splice(selected[question.idx].indexOf(answer.idx), 1)
                                               }
                                               this.setState({
                                                   selected: selected
                                               })
                                           }
                                       }
                                />
                                {answer.text}
                                </Label>
                            </FormGroup>
                        )))
                    }
                </CardBody>
                <CardFooter>
                    <p className={'text-center'}>
                        { current + 1} / { max }
                    </p>
                    <div>
                        {
                            current > 0 &&
                            <Button color='default' onClick={() => {this.setState({current: current - 1})}}>Zurück</Button>
                        }
                        {
                            current < max - 1 &&
                            <Button color={'primary'} style={{'float': 'right'}} onClick={() => {this.setState({current: current + 1})}}>Weiter</Button>
                        }
                        {
                            current == max - 1 &&
                            <Button style={{'float': 'right'}} color='danger' onClick={this.onSubmit}>Abgabe</Button>
                        }
                    </div>
                </CardFooter>
            </Card>
        )
    }
}

@connect(
    state => ({
      apa: state.apa
    }),
    dispatch => ({
      login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Test extends Component {

    render() {
        const isLoading = this.props.apa.isLoading;
        if(isLoading) {
            return <Loading/>
        }
        const access_code = this.props.apa.user.access_code;
        if(access_code.status === 1 || access_code.status === 3) {
            return <Redirect to={'/training/status'} />
        }
        const customer_name = this.props.apa.user.access_code.training.customer_name;
        const training_name = this.props.apa.user.access_code.training.name;
        const training = this.props.apa.user.access_code.training;
        const data = training.data;
        const questions = [];
        for (let category of data) {
            questions.push(
                ...chooseQuestions(category.questionList, category.number)
            )
        }
        return (
            <Container>
                <h1>
                    { customer_name }
                </h1>
                <h2>
                    { training_name }
                </h2>
                <T questions={questions} />
            </Container>
        )
    }
}

Test.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
